import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-checkbox',
  templateUrl: './custom-checkbox.component.html',
  styleUrl: './custom-checkbox.component.scss',
})
export class CustomCheckboxComponent implements OnInit {
  @Input() label: string;
  @Input() value: any;
  @Input() controlName: string = '';
  @Input() class: string = '';
  @Input() formGroup: FormGroup;
  @Input() disabled = false;
  @Input() checked = false;
  @Output() change = new EventEmitter<any>();
  @Input() type: string;
  @Input() options: any[] = [];
  ngOnInit() {

  }
}
